module.exports = __webpack_public_path__ + "resources/img/img_plantpulse_m_en.266a93695546875a8eea213cb4b41c4b.png";